// Copyright ©️ 2026 eVolve MEP, LLC

import { type WorkOrder, useEvolvePaginatedGet } from '@evolvemep/api-ts';

import { ActivityFeed } from 'components/Mantine/ActivityFeed';
import { useCustomStatuses } from 'components/Mantine/StatusEditor/useCustomStatuses';
import { isNotNil } from 'helpers/isNotNil';

type Props = {
  workOrder: WorkOrder;
};

export const WorkOrderActivityFeed = ({ workOrder }: Props) => {
  const { statusMap, stateColorMap } = useCustomStatuses('Work Order');
  const paginatedGet = useEvolvePaginatedGet(`shop/workOrder/${workOrder.workOrderId}/statusHistory`);

  return (
    <ActivityFeed
      paginatedGet={paginatedGet}
      getActivityFeedItem={(e) => ({
        ...e,
        label:
          (isNotNil(e.workOrderStatusId) && statusMap[e.workOrderStatusId]?.name) ||
          stateColorMap[e.workOrderStateName].label,
      })}
      currentStatus={workOrder.workOrderStatusId ?? workOrder.workOrderStateId}
    />
  );
};
